import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import { ListingsHeader } from 'src/components/organisms/ListingsHeader/ListingsHeader';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectTotalActiveOptions } from 'src/redux/productsQuery/selectors/selectors';
import { actions } from 'src/redux/productsQuery/slice';
import type { AppThunkDispatch } from 'src/redux/store';

export const ListingsHeaderContainer = ({
  stickyTopBanner = false,
}: {
  stickyTopBanner?: boolean;
}) => {
  const dispatch = useDispatch<AppThunkDispatch>();
  const state = useSelector((state: ReduxApplicationState) => state);
  const totalActiveFacetOptions = selectTotalActiveOptions(state);
  const totalProducts = state.products.totalProducts;

  const openListingsControlsDrawer = () => {
    sendGAEvent({
      event: 'custom_event_v2',
      event_name: 'filter_interaction',
      event_details: 'open modal',
      content_type: 'filters',
      modal_details: {
        name: 'plp_filter_facet',
        type: 'mobile_drawer',
        action: 'open',
        page_type: 'plp',
      },
    });
    dispatch(actions.openModal());
  };

  return (
    <ListingsHeader
      onButtonClick={openListingsControlsDrawer}
      stickyOffsetPx={stickyTopBanner ? 36 : 0}
      totalActiveFacetOptions={totalActiveFacetOptions}
      totalProducts={totalProducts}
    />
  );
};
